import { mapGetters, mapMutations } from 'vuex';
import * as constants from '../constants';

export default {
  computed: {
    ...mapGetters({
      breadcrumbs: 'core/breadcrumbs',
    }),
  },
  methods: {
    routeBreadcrumbs(dynamic = []) {
      const { breadcrumbs = [] } = this.$route.meta;
      const breadcrumbsWithTranslation = breadcrumbs.map((crumbs) => ({
        ...crumbs,
        text: this.$t(crumbs.text),
      }));
      this.setBreadcrumbs([...breadcrumbsWithTranslation, ...dynamic]);
    },
    ...mapMutations({
      setBreadcrumbs: `core/${constants.CORE_BREADCRUMBS_SET}`,
      pushBreadcrumbs: `core/${constants.CORE_BREADCRUMBS_PUSH}`,
      popBreadcrumbs: `core/${constants.CORE_BREADCRUMBS_POP}`,
      emptyBreadcrumbs: `core/${constants.CORE_BREADCRUMBS_EMPTY}`,
      replaceBreadcrumb: `core/${constants.CORE_BREADCRUMBS_REPLACE}`,
    }),
  },
};
